// AUTO-GENERATED — do not edit by hand.
// EXCEPTION: chairsRow.alt was hand-corrected (from-entrance wide shot, not
// a station detail). Carry that fix into the generator before regenerating.
// Photo asset manifest for KD Barbershop interior photography.
// Regenerate with the asset optimization script.

export type PhotoSize = { src: string; width: number; height: number };
export type PhotoAsset = {
  hero: PhotoSize;
  med: PhotoSize;
  thumb: PhotoSize;
  fallback: PhotoSize;
  width: number;  // native aspect (from hero size)
  height: number;
  alt: string;
};

const BASE = '/photos';

export const photoManifest = {
  domino: {
    hero:     { src: `${BASE}/kd-domino-hero.webp`,  width: 1800,  height: 2400  },
    med:      { src: `${BASE}/kd-domino-med.webp`,   width: 1050,   height: 1400   },
    thumb:    { src: `${BASE}/kd-domino-thumb.webp`, width: 450, height: 600 },
    fallback: { src: `${BASE}/kd-domino.jpg`,        width: 1200, height: 1600 },
    width: 1800,
    height: 2400,
    alt: 'Domino table on the KD Barbershop floor with the marble accent wall and hexagonal LED ceiling behind',
  },
  chairsRow: {
    hero:     { src: `${BASE}/kd-chairs-row-hero.webp`,  width: 2400,  height: 1800  },
    med:      { src: `${BASE}/kd-chairs-row-med.webp`,   width: 1400,   height: 1050   },
    thumb:    { src: `${BASE}/kd-chairs-row-thumb.webp`, width: 600, height: 450 },
    fallback: { src: `${BASE}/kd-chairs-row.jpg`,        width: 1600, height: 1200 },
    width: 2400,
    height: 1800,
    alt: 'The KD Barbershop floor viewed from the entrance, hexagonal LED ceiling overhead and chairs receding down the right wall',
  },
  shopWide: {
    hero:     { src: `${BASE}/kd-shop-wide-hero.webp`,  width: 1800,  height: 2400  },
    med:      { src: `${BASE}/kd-shop-wide-med.webp`,   width: 1050,   height: 1400   },
    thumb:    { src: `${BASE}/kd-shop-wide-thumb.webp`, width: 450, height: 600 },
    fallback: { src: `${BASE}/kd-shop-wide.jpg`,        width: 1200, height: 1600 },
    width: 1800,
    height: 2400,
    alt: 'Wide view of the KD Barbershop floor with pool table centered and chairs on both walls',
  },
  stationsDetail: {
    hero:     { src: `${BASE}/kd-stations-detail-hero.webp`,  width: 2400,  height: 1800  },
    med:      { src: `${BASE}/kd-stations-detail-med.webp`,   width: 1400,   height: 1050   },
    thumb:    { src: `${BASE}/kd-stations-detail-thumb.webp`, width: 600, height: 450 },
    fallback: { src: `${BASE}/kd-stations-detail.jpg`,        width: 1600, height: 1200 },
    width: 2400,
    height: 1800,
    alt: 'Barber stations and framed KD certifications on the wall',
  },
  cutAdult: {
    hero:     { src: `${BASE}/kd-cut-adult-hero.webp`,  width: 1800,  height: 2400  },
    med:      { src: `${BASE}/kd-cut-adult-med.webp`,   width: 1050,   height: 1400   },
    thumb:    { src: `${BASE}/kd-cut-adult-thumb.webp`, width: 450, height: 600 },
    fallback: { src: `${BASE}/kd-cut-adult.jpg`,        width: 1200, height: 1600 },
    width: 1800,
    height: 2400,
    alt: 'A fresh fade at KD Barbershop, side profile, hexagonal LED ceiling in the background',
  },
  poolCinematic: {
    hero:     { src: `${BASE}/kd-pool-cinematic-hero.webp`,  width: 1800,  height: 2400  },
    med:      { src: `${BASE}/kd-pool-cinematic-med.webp`,   width: 1050,   height: 1400   },
    thumb:    { src: `${BASE}/kd-pool-cinematic-thumb.webp`, width: 450, height: 600 },
    fallback: { src: `${BASE}/kd-pool-cinematic.jpg`,        width: 1200, height: 1600 },
    width: 1800,
    height: 2400,
    alt: 'Pool table at KD Barbershop with the hexagonal LED ceiling glowing overhead',
  },
  marble: {
    hero:     { src: `${BASE}/kd-marble-hero.webp`,  width: 1300,  height: 900  },
    med:      { src: `${BASE}/kd-marble-med.webp`,   width: 1300,   height: 900   },
    thumb:    { src: `${BASE}/kd-marble-thumb.webp`, width: 600, height: 415 },
    fallback: { src: `${BASE}/kd-marble.jpg`,        width: 1300, height: 900 },
    width: 1300,
    height: 900,
    alt: 'The signature marble accent wall at KD Barbershop',
  },
  shopLandscape: {
    hero:     { src: `${BASE}/kd-shop-landscape-hero.webp`,  width: 2400,  height: 1200  },
    med:      { src: `${BASE}/kd-shop-landscape-med.webp`,   width: 1400,   height: 700   },
    thumb:    { src: `${BASE}/kd-shop-landscape-thumb.webp`, width: 600, height: 300 },
    fallback: { src: `${BASE}/kd-shop-landscape.jpg`,        width: 1600, height: 800 },
    width: 2400,
    height: 1200,
    alt: 'The full KD Barbershop floor: marble wall, hexagonal ceiling, pool table, ATM, chairs and dominos',
  },
} as const satisfies Record<string, PhotoAsset>;

export type PhotoKey = keyof typeof photoManifest;